import React, { useEffect } from 'react'
import styled from '@emotion/styled'
import Modal from '@components/common/modal/Modal'
import MenuGenerationChat from './MenuGenerationChat'
import MenuGenerationSchedule from './MenuGenerationSchedule'
import { useMenuGeneration } from './useMenuGeneration'

interface MenuGenerationModalProps {
  clientSettingsId: string
  clientName: string
  userId: string
  hideModal: () => void
  onMenusCreated?: () => void
}

const MenuGenerationModal: React.FC<MenuGenerationModalProps> = ({
  clientSettingsId,
  clientName,
  userId,
  hideModal,
  onMenusCreated,
}) => {
  const {
    chatId,
    messages,
    scheduleJson,
    conceptMap,
    isLoading,
    loadingStatus,
    isAccepting,
    acceptResult,
    acceptProgress,
    isCreating,
    createResult,
    createProgress,
    error,
    createChat,
    sendMessage,
    acceptSchedule,
    createDateMenus,
  } = useMenuGeneration()

  useEffect(() => {
    createChat(userId, clientSettingsId)
  }, [userId, clientSettingsId, createChat])

  return (
    <Modal
      title={`Generate Menu — ${clientName}`}
      width="900px"
      hideModal={hideModal}
    >
      <ModalContent>
        <ChatSection hasSchedule={!!scheduleJson}>
          {chatId ? (
            <MenuGenerationChat
              messages={messages}
              isLoading={isLoading}
              loadingStatus={loadingStatus}
              error={error}
              onSendMessage={sendMessage}
            />
          ) : (
            <LoadingState>Initializing chat...</LoadingState>
          )}
        </ChatSection>
        {scheduleJson && (
          <ScheduleSection>
            <MenuGenerationSchedule
              schedule={scheduleJson}
              conceptMap={conceptMap}
              onAcceptSchedule={() => acceptSchedule(clientSettingsId)}
              isAccepting={isAccepting}
              acceptResult={acceptResult}
              acceptProgress={acceptProgress}
              acceptError={error}
              onCreateMenus={(activeMap) =>
                createDateMenus(clientSettingsId, activeMap)
              }
              isCreating={isCreating}
              createResult={createResult}
              createProgress={createProgress}
              onCloseAll={onMenusCreated}
            />
          </ScheduleSection>
        )}
      </ModalContent>
    </Modal>
  )
}

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 70vh;
`

const ChatSection = styled.div<{ hasSchedule: boolean }>`
  flex: 1;
  min-height: 300px;
  max-height: ${(props) => (props.hasSchedule ? '40vh' : '60vh')};
  overflow-y: auto;
`

const ScheduleSection = styled.div`
  border-top: 2px solid #e0e0e0;
  max-height: 30vh;
  overflow-y: auto;
`

const LoadingState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: #888;
  font-size: 14px;
`

export default MenuGenerationModal
